var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app',{attrs:{"bootstrapped":_vm.bootstrapped,"loading":_vm.loading,"loading-message":_vm.loadingMessage,"on-loading":_vm.handlePageLoading}},[_c('VueAnnouncer'),(_vm.errors)?_c('modal-error'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }